module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/pk-0e17f31b0f156316ef2028671d12825f.svg";